// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Diamond24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Diamond24Filled: FC<Diamond24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M4.6 6 2.475 3.875l1.425-1.4L6.025 4.6 4.6 6Zm6.425-2V1h2v3h-2ZM19.4 6l-1.425-1.425L20.1 2.45l1.425 1.425L19.4 6Zm-7.375 15L3.95 13H20.1l-8.075 8Zm-4-15h8l4.1 5h-16.2l4.1-5Z" />
        </svg>
    );
};

export default Diamond24Filled;
